import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { MailTemplateService } from '../../_services/mail-template.service';
import { AlertsService } from 'angular-alert-module';

@Component({
    selector: 'app-mail-template',
    templateUrl: './mail-template.component.html',
    styleUrls: ['./mail-template.component.css']
})
export class MailTemplateComponent implements OnInit {

    model: any = {};
    modelMail: any = {};
    message: string = '';
    messageData = '';
    MESSAGE_SUCCESS = '保存成功！';
    MESSAGE_ERROR = 'データ保存が失敗しました。';
    /*
     * array data mail template
     * type = 1: mail template active
     * type = 2: mail template inactive
     * type = 3: mail template user register account on web
     */
    arrDataMailTemplate: any = [
        {type: 1, name: '有効なメールテンプレート'},
        {type: 2, name: '無効なメールテンプレート'},
        {type: 3, name: 'これはユーザがウェブでのアカウントを登録するメールテンプレートです。'}
    ];
    categoryMail: string = '';
    type: number;

    constructor(
        private mailTemplateService: MailTemplateService,
        private alerts: AlertsService
    ) { }

    ngOnInit() {}

    onChangeCondition(event) {
        this.mailTemplateService.gets(event.target.value).subscribe(data => {
            switch (event.target.value) {
                case '1':
                    this.modelMail.title = data.title;
                    this.modelMail.content = data.content;
                    this.categoryMail = '有効なメールテンプレート';
                    this.type = event.target.value;
                    this.messageData = '';
                    break;
                case '2':
                    this.modelMail.title = data.title;
                    this.modelMail.content = data.content;
                    this.categoryMail = '無効なメールテンプレート';
                    this.type = event.target.value;
                    this.messageData = '';
                    break;
                case '3':
                    this.modelMail.title = data.title;
                    this.modelMail.content = data.content;
                    this.categoryMail = 'これはユーザがウェブでのアカウントを登録するメールテンプレートです。';
                    this.type = event.target.value;
                    this.messageData = '';
                    break;
                default:
                    this.modelMail.title = '';
                    this.modelMail.content = '';
                    this.categoryMail = '';
                    this.type = 0;
                    this.messageData = '';
                    break;
            }
        }, error => {
            this.message = error;
        });
    }

    saveAll() {
        if (this.type == undefined || this.type == 0) {
            $("div.failure").fadeIn(300).delay(3000).fadeOut(400);
            return false;
        }
        this.model.title = $('#title').val();
        this.model.content = $('#content').val();
        this.model.type = this.type;
        this.mailTemplateService.save(this.model).subscribe(
            data => {
                this.messageData = this.MESSAGE_SUCCESS;
            }, error => {
                this.messageData = this.MESSAGE_ERROR;
            }
        );
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/mail-template/mail-template.component.ts